module.exports = __webpack_public_path__ + "img/MEDIA080.5ca10764.jpg";